module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-th-TH.9fd0bedc.jpg";